import styled from 'styled-components'

export const Textarea = styled.textarea`
  width: 100%;
  font-family: inherit;
  font-size: 16px;
  resize: none;
`
